import { AbstractEntity } from '@app/shared/abstract/abstract-entity';
import { PageMetadata } from '@app/shared/abstract/page-metadata';

export type RemediationStrand = 'cascade_not_absorbed' | 'hand_edited' | 'ghost_row';

export type RemediationAction = 'fix' | 'approve_override' | 'reassign';

/**
 * TVG-176: one live remediation case (one confirmed event whose payment
 * schedule currently looks wrong). `id` mirrors `event_id` so the data table
 * can key row selection on it.
 */
export interface RemediationCase extends AbstractEntity {
  event_id: number;
  event_name: string;
  event_reference: string | null;
  venue_id: number | null;
  venue_name: string | null;
  strand: RemediationStrand;
  stored: number;
  calculated: number;
  difference: number;
  actions: RemediationAction[];
  ghost_payment_ids?: number[];
  final_payment_id?: number;
}

export interface RemediationStrandCounts {
  cascade_not_absorbed: number;
  hand_edited: number;
  ghost_row: number;
}

export interface RemediationListResponse {
  data: RemediationCase[];
  meta: PageMetadata;
  strand_counts: RemediationStrandCounts;
  total: number;
}

export const STRAND_LABELS: Record<RemediationStrand, string> = {
  cascade_not_absorbed: 'Cascade not absorbed',
  hand_edited: 'Hand-edited',
  ghost_row: 'Ghost row',
};
